var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "studip-five-stars",
    },
    [
      _vm._l(_vm.fullStars, function (index) {
        return _c("studip-icon", {
          key: index + "full",
          attrs: {
            shape: "star",
            role: _vm.role,
            size: _vm.size,
          },
        })
      }),
      _vm.halfStar
        ? _c("studip-icon", {
            attrs: {
              shape: "star-halffull",
              role: _vm.role,
              size: _vm.size,
            },
          })
        : _vm._e(),
      _vm._l(_vm.emptyStars, function (index) {
        return _c("studip-icon", {
          key: index + "empty",
          attrs: {
            shape: "star-empty",
            role: _vm.role,
            size: _vm.size,
          },
        })
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }